import React from 'react';
import { motion } from 'motion/react';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface HeroProps {
  onCtaClick: () => void;
}

export const Hero: React.FC<HeroProps> = ({ onCtaClick }) => {
  const navigate = useNavigate();

  return (
    <section className="relative w-full h-[85vh] overflow-hidden bg-[#061970]">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center"
        style={{ 
          backgroundImage: "url('/home.jpg')",
          filter: "brightness(0.6) contrast(1.2)" 
        }}
      />
      
      {/* Geometric Overlays */}
      <div className="absolute top-0 left-0 w-full h-full z-10 pointer-events-none">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#061970] to-transparent opacity-80" />
        <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-[#061970] to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-20 container mx-auto px-4 h-full flex flex-col justify-center items-start">
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="inline-block bg-[#FF7F32] px-4 py-1 mb-4 skew-x-[-15deg]">
            <span className="block skew-x-[15deg] font-bold text-white uppercase tracking-widest">Nueva Colección</span>
          </div>
          
          <h1 className="text-6xl md:text-8xl font-black italic text-white leading-none mb-2 uppercase tracking-tighter">
            Línea <span className="text-[#459EDF]">2026</span>
          </h1>
          
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 italic opacity-90">
            Protección en Movimiento
          </h2>
          
          <button 
            onClick={onCtaClick}
            className="group relative px-8 py-4 bg-[#459EDF] text-white font-black text-xl uppercase italic tracking-wider hover:bg-white hover:text-[#061970] transition-colors duration-300 rounded-[48px]"
          >
            <span className="flex items-center gap-2">
              Explorar Catálogo <ArrowRight className="w-6 h-6" />
            </span>
          </button>
        </motion.div>
      </div>

      {/* Certifications Banner */}
      <div className="absolute bottom-0 left-0 w-full bg-black border-t border-[#459EDF] z-20 py-4 backdrop-blur-sm">
        <div className="container mx-auto px-4 flex justify-between items-center">
            <div className="flex items-center gap-8 text-white/80 whitespace-nowrap">
                <button 
                  onClick={() => navigate('/certificaciones')}
                  className="flex items-center gap-2 hover:text-white transition-colors group"
                >
                    <ShieldCheck className="w-8 h-8 text-[#FF7F32] group-hover:scale-110 transition-transform" />
                    <div className="flex flex-col">
                        <span className="font-bold text-lg leading-none">DOT</span>
                        <span className="text-xs uppercase">Certified</span>
                    </div>
                </button>
                <div className="w-px h-8 bg-white/20" />
                <button 
                  onClick={() => navigate('/certificaciones')}
                  className="flex items-center gap-2 hover:text-white transition-colors group"
                >
                    <ShieldCheck className="w-8 h-8 text-[#459EDF] group-hover:scale-110 transition-transform" />
                    <div className="flex flex-col">
                        <span className="font-bold text-lg leading-none">ECE 22.06</span>
                        <span className="text-xs uppercase">Approved</span>
                    </div>
                </button>
            </div>
        </div>
      </div>
    </section>
  );
};
